/* VEBXORA — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.vx-reveal:not(.vx-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('vx-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initTilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-vx-tilt]').forEach(function (card) {
      if (card.dataset.vxTiltOn) return;
      card.dataset.vxTiltOn = '1';
      var max = parseFloat(card.getAttribute('data-vx-tilt')) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  function initCount() {
    var els = document.querySelectorAll('[data-vx-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-vx-count')) || 0;
      var suffix = el.getAttribute('data-vx-suffix') || '';
      var prefix = el.getAttribute('data-vx-prefix') || '';
      if (reduce) { el.textContent = prefix + target.toLocaleString('es-CL') + suffix; return; }
      var start = null, dur = 1600;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var v = Math.round(target * (1 - Math.pow(1 - p, 3)));
        el.textContent = prefix + v.toLocaleString('es-CL') + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Página de producto ---------- */
  function initProduct() {
    document.querySelectorAll('[data-vx-pdp]').forEach(function (root) {
      if (root.dataset.vxReady) return;
      root.dataset.vxReady = '1';

      // Entrega estimada: hoy + N días hábiles (sin sábados ni domingos), en hora de Chile
      var eta = root.querySelector('[data-vx-eta]');
      if (eta) {
        var addBiz = function (d, n) {
          var r = new Date(d.getTime());
          while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
          return r;
        };
        var fmt = function (d) {
          try { return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'America/Santiago' }); }
          catch (e) { return d.toLocaleDateString('es-CL'); }
        };
        var now = new Date();
        var a = eta.querySelector('[data-vx-eta-a]');
        var b = eta.querySelector('[data-vx-eta-b]');
        if (a) a.textContent = fmt(addBiz(now, parseInt(eta.getAttribute('data-min'), 10) || 2));
        if (b) b.textContent = fmt(addBiz(now, parseInt(eta.getAttribute('data-max'), 10) || 6));
        eta.hidden = false;
      }

      // Galería
      var slides = root.querySelectorAll('.vx-gallery__main > img, .vx-gallery__main > video');
      var thumbs = root.querySelectorAll('.vx-gallery__thumb');
      var current = 0;
      function show(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
        var at = thumbs[current];
        if (at && at.scrollIntoView) {
          var wrap = at.parentNode;
          wrap.scrollTo({ left: at.offsetLeft - wrap.clientWidth / 2 + at.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = root.querySelector('.vx-gallery__nav--prev');
      var next = root.querySelector('.vx-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var main = root.querySelector('.vx-gallery__main');
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }
      function showMedia(mediaId) {
        if (!mediaId) return;
        slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(mediaId)) show(k); });
      }

      // Variantes
      var dataEl = root.querySelector('[data-vx-variants]');
      var variants = [];
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelectorAll('[data-vx-price]');
      var priceWas = root.querySelectorAll('[data-vx-was]');
      var saveEl = root.querySelector('[data-vx-save]');
      var badgeEl = root.querySelector('[data-vx-off]');
      var addBtns = root.querySelectorAll('[data-vx-add]');
      var buyBtn = root.querySelector('[data-vx-buynow]');
      var labelAdd = root.getAttribute('data-label-add') || 'Agregar al carrito';
      var labelSold = root.getAttribute('data-label-sold') || 'Agotado';

      function selected() {
        var vals = [];
        root.querySelectorAll('.vx-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
        });
        return vals;
      }
      function update() {
        if (!variants.length) return;
        var vals = selected();
        var v = variants.find(function (x) {
          // vals[i] puede no existir (producto sin opciones, "Default Title"): se toma como "cualquiera"
          return x.options.every(function (o, i) { return vals[i] == null || o === vals[i]; });
        });
        root.querySelectorAll('.vx-opt').forEach(function (fs, idx) {
          var c = fs.querySelector('input:checked');
          var lab = fs.querySelector('[data-vx-optval]');
          if (lab && c) lab.textContent = c.value;
          fs.querySelectorAll('.vx-pill').forEach(function (p) {
            var val = p.querySelector('input').value;
            var ok = variants.some(function (x) {
              return x.available && x.options[idx] === val && x.options.every(function (o, i) { return i === idx || vals[i] == null || o === vals[i]; });
            });
            p.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) {
          addBtns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = labelSold; });
          if (buyBtn) buyBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (el) { el.textContent = v.price; });
        priceWas.forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
        if (saveEl) { saveEl.textContent = v.save || ''; saveEl.hidden = !v.save; }
        if (badgeEl) { badgeEl.textContent = v.off || ''; badgeEl.hidden = !v.off; }
        addBtns.forEach(function (b) {
          b.disabled = !v.available;
          b.querySelector('span').textContent = v.available ? labelAdd : labelSold;
        });
        if (buyBtn) buyBtn.disabled = !v.available;
        var st = root.querySelector('[data-vx-stock]');
        if (st) {
          st.toggleAttribute('data-off', !v.available);
          var stt = st.querySelector('[data-vx-stock-text]');
          if (stt) stt.textContent = v.available ? st.getAttribute('data-in') : st.getAttribute('data-out');
        }
        showMedia(v.media);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      root.querySelectorAll('.vx-opt input').forEach(function (inp) { inp.addEventListener('change', update); });
      update();

      // Cantidad
      var qty = root.querySelector('.vx-qty input');
      root.querySelectorAll('.vx-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n += b.getAttribute('data-step') === '-1' ? -1 : 1;
          qty.value = Math.max(1, n);
        });
      });

      // Comprar ahora: añade y va directo al pago
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          if (!idInput) return;
          buyBtn.disabled = true;
          var body = { items: [{ id: parseInt(idInput.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 }] };
          var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(base + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) {
            if (!r.ok) throw new Error('add');
            window.location.href = base + 'checkout';
          }).catch(function () {
            buyBtn.disabled = false;
            var form = root.querySelector('form[action*="/cart/add"]');
            if (form) form.submit();
          });
        });
      }

      // Barra fija en móvil
      var sticky = root.querySelector('.vx-sticky');
      var anchor = root.querySelector('.vx-buy__row');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        var so = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var past = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', past);
          });
        });
        so.observe(anchor);
        var sbtn = sticky.querySelector('[data-vx-sticky-add]');
        if (sbtn) sbtn.addEventListener('click', function () {
          var a = root.querySelector('[data-vx-add]') || root.querySelector('[data-vx-buynow]');
          if (a && !a.disabled) a.click();
        });
      }
    });
  }

  function initAll() {
    document.documentElement.classList.remove('vx-no-js');
    initReveal();
    initTilt();
    initCount();
    initProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Editor de Shopify: re-inicializa al añadir/editar secciones
  document.addEventListener('shopify:section:load', initAll);
})();
